// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from 'mz-ui-kit/utils'

export { Container, BrandContainer } from '../CreditCardItem/elements'

export const Label = styled('div', {
  display: 'flex',
  flexFlow: 'column nowrap',
})

export const LabelName = styled('span', {
  fontWeight: 'bold',
})

export const LabelValue = styled('span', {
  display: 'block',
  ...getScreenStyles('xs', {
    display: 'none',
  }),
})
